import React, { useState } from "react";
import tools from "../../../../../helpers/tools";
import SaveBtn from "../../../../common/SaveBtn";
import Control from "../../../../common/Control";
import useStore from "../../../../../context/useStore";

const EpCallingV2 = ({ sessionData, onCallingDone }) => {
  const [gState] = useStore();
  const {
    ep,
    jury,
    callMember,
    saveCalling,
    isSavingCalling,
    writerPresident,
    setWriterPresident,
    saveWriterPresident,
    isSavingWriters,
  } = sessionData;

  const myId = gState.auth.user.id;
  const isWriter = myId === ep.writer;

  const [absentFilter, setAbsentFilter] = useState("");
  const [presentFilter, setPresentFilter] = useState("");

  const matchesFilter = (user, filter) => {
    if (!filter.trim()) return true;
    const search = filter.toLowerCase();
    const fullname = tools.getFullname(user).toLowerCase();
    return fullname.includes(search);
  };

  const absentMembers = jury.filter((j) => !j.isPresent);
  const presentMembers = jury.filter((j) => j.isPresent);
  const filteredAbsent = absentMembers.filter((j) =>
    matchesFilter(j.userManager, absentFilter),
  );
  const filteredPresent = presentMembers.filter((j) =>
    matchesFilter(j.userManager, presentFilter),
  );
  const totalMembers = jury.length;
  const progressPercent =
    totalMembers > 0
      ? Math.round((presentMembers.length / totalMembers) * 100)
      : 0;

  if (!isWriter) {
    return (
      <div
        className="animated fadeInDown faster"
        style={{ maxWidth: 600, margin: "60px auto" }}
      >
        <div
          className="text-center p-5 rounded"
          style={{
            background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
            border: "1px solid #dee2e6",
          }}
        >
          <div
            className="d-inline-flex align-items-center justify-content-center mb-3"
            style={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              background: "#fff",
              boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
            }}
          >
            <i
              className="fa fa-lock"
              style={{ fontSize: 24, color: "#adb5bd" }}
            />
          </div>
          <p className="mb-3" style={{ fontSize: 15, color: "#495057" }}>
            Vous ne pouvez pas modifier la liste d'appel car vous n'êtes pas
            rédacteur sur cet EP.
          </p>
          <button
            className="btn btn-default"
            onClick={() => window.location.reload()}
            style={{ fontSize: 14 }}
          >
            <i className="fa fa-refresh mr-2" />
            Actualiser la page
          </button>
        </div>
      </div>
    );
  }

  const MemberCard = ({ user, isPresent }) => {
    const initials =
      (user.firstname?.[0] || "").toUpperCase() +
      (user.lastname?.[0] || "").toUpperCase();

    return (
      <div
        className="d-flex align-items-center justify-content-between p-3 mb-2 rounded "
        style={{
          background: isPresent
            ? "linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)"
            : "#fff",
          border: isPresent ? "1px solid #86efac" : "1px solid #e9ecef",
          transition: "all 0.3s ease",
        }}
      >
        <div className="d-flex align-items-center" style={{ gap: 12 }}>
          <div
            className="d-flex align-items-center justify-content-center font-weight-bold"
            style={{
              width: 40,
              height: 40,
              borderRadius: "50%",
              fontSize: 14,
              background: isPresent
                ? "linear-gradient(135deg, #22c55e, #16a34a)"
                : "linear-gradient(135deg, #e2e8f0, #cbd5e1)",
              color: isPresent ? "#fff" : "#64748b",
              letterSpacing: 1,
              flexShrink: 0,
            }}
          >
            {initials || <i className="fa fa-user" style={{ fontSize: 14 }} />}
          </div>
          <div>
            <div
              className="font-weight-bold"
              style={{ fontSize: 14, color: "#1e293b" }}
            >
              {tools.getFullname(user)}
            </div>
            <div
              style={{ fontSize: 12, color: isPresent ? "#16a34a" : "#94a3b8" }}
            >
              {isPresent ? "Présent(e)" : "En attente"}
            </div>
          </div>
        </div>
        <button
          className="btn btn-sm"
          onClick={() => callMember(user.id, !isPresent)}
          style={{
            width: 38,
            height: 38,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: isPresent
              ? "#fee2e2"
              : "linear-gradient(135deg, #22c55e, #16a34a)",
            color: isPresent ? "#dc2626" : "#fff",
            border: "none",
            transition: "all 0.2s ease",
            boxShadow: isPresent ? "none" : "0 2px 6px rgba(34,197,94,0.3)",
          }}
        >
          <i
            className={`fa fa-${isPresent ? "times" : "check"}`}
            style={{ fontSize: 14 }}
          />
        </button>
      </div>
    );
  };

  return (
    <div className="animated fadeInUp faster">
      {/* Header */}
      <div
        className="text-center mb-4 p-4 rounded"
        style={{
          background: "linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)",
          color: "#fff",
        }}
      >
        <h3
          className="mb-2"
          style={{ fontSize: 22, fontWeight: 700, letterSpacing: -0.3 }}
        >
          Appel des membres du jury
        </h3>
        <p className="mb-3" style={{ fontSize: 14, opacity: 0.85 }}>
          Marquez les membres présents pour constituer le jury de cette session
        </p>

        {/* Progress ring */}
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ gap: 30 }}
        >
          <div className="text-center">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-1"
              style={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                background: `conic-gradient(#34d399 ${progressPercent * 3.6}deg, rgba(255,255,255,0.15) 0deg)`,
                position: "relative",
              }}
            >
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: 58,
                  height: 58,
                  borderRadius: "50%",
                  background:
                    "linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)",
                }}
              >
                <span style={{ fontSize: 20, fontWeight: 700 }}>
                  {presentMembers.length}
                </span>
              </div>
            </div>
            <div style={{ fontSize: 12, opacity: 0.8 }}>Présent(s)</div>
          </div>

          <div
            style={{
              width: 1,
              height: 50,
              background: "rgba(255,255,255,0.2)",
            }}
          />

          <div className="text-center">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-1"
              style={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.1)",
                border: "2px solid rgba(255,255,255,0.2)",
              }}
            >
              <span style={{ fontSize: 20, fontWeight: 700 }}>
                {absentMembers.length}
              </span>
            </div>
            <div style={{ fontSize: 12, opacity: 0.8 }}>En attente</div>
          </div>

          <div
            style={{
              width: 1,
              height: 50,
              background: "rgba(255,255,255,0.2)",
            }}
          />

          <div className="text-center">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-1"
              style={{
                width: 72,
                height: 72,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.1)",
                border: "2px solid rgba(255,255,255,0.2)",
              }}
            >
              <span style={{ fontSize: 20, fontWeight: 700 }}>
                {totalMembers}
              </span>
            </div>
            <div style={{ fontSize: 12, opacity: 0.8 }}>Total inscrits</div>
          </div>
        </div>
      </div>

      {/* Members grid */}
      <div className="row">
        {/* En attente */}
        <div className="col-12 col-md-6 mb-4">
          <div
            className="p-3 rounded h-100"
            style={{ background: "#f8fafc", border: "1px solid #e2e8f0" }}
          >
            <div className="d-flex align-items-center mb-3" style={{ gap: 10 }}>
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  background: "#e2e8f0",
                }}
              >
                <i
                  className="fa fa-clock-o"
                  style={{ fontSize: 14, color: "#64748b" }}
                />
              </div>
              <div>
                <div
                  className="font-weight-bold"
                  style={{ fontSize: 15, color: "#334155" }}
                >
                  En attente
                </div>
                <div style={{ fontSize: 12, color: "#94a3b8" }}>
                  {absentMembers.length} membre(s)
                </div>
              </div>
            </div>
            {absentMembers.length > 0 && (
              <div className="mb-2" style={{ position: "relative" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Filtrer par nom..."
                  value={absentFilter}
                  onChange={(e) => setAbsentFilter(e.target.value)}
                  style={{ fontSize: 13, borderRadius: 8, paddingRight: 30 }}
                />
                {absentFilter && (
                  <button
                    onClick={() => setAbsentFilter("")}
                    style={{
                      position: "absolute",
                      right: 8,
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#94a3b8",
                      fontSize: 14,
                      padding: 0,
                      lineHeight: 1,
                    }}
                  >
                    <i className="fa fa-times" />
                  </button>
                )}
              </div>
            )}
            {absentMembers.length === 0 ? (
              <div
                className="text-center p-4 rounded"
                style={{ background: "#fff", border: "1px dashed #cbd5e1" }}
              >
                <i
                  className="fa fa-check-circle d-block mb-2"
                  style={{ fontSize: 24, color: "#22c55e" }}
                />
                <span style={{ fontSize: 13, color: "#64748b" }}>
                  Tous les membres ont été appelés
                </span>
              </div>
            ) : filteredAbsent.length === 0 ? (
              <div
                className="text-center p-4 rounded"
                style={{ background: "#fff", border: "1px dashed #cbd5e1" }}
              >
                <i
                  className="fa fa-search d-block mb-2"
                  style={{ fontSize: 20, color: "#94a3b8" }}
                />
                <span style={{ fontSize: 13, color: "#64748b" }}>
                  Aucun résultat pour « {absentFilter} »
                </span>
                <button
                  className="btn btn-sm btn-link d-block mx-auto mt-2"
                  onClick={() => setAbsentFilter("")}
                  style={{ fontSize: 12 }}
                >
                  <i className="fa fa-times mr-1" />
                  Effacer le filtre
                </button>
              </div>
            ) : (
              filteredAbsent.map((j) => (
                <MemberCard
                  key={`absent-${j.userManager.id}`}
                  user={j.userManager}
                  isPresent={false}
                />
              ))
            )}
          </div>
        </div>

        {/* Présents */}
        <div className="col-12 col-md-6 mb-4">
          <div
            className="p-3 rounded h-100"
            style={{
              background: "linear-gradient(180deg, #f0fdf4 0%, #f8fafc 100%)",
              border: "1px solid #bbf7d0",
            }}
          >
            <div className="d-flex align-items-center mb-3" style={{ gap: 10 }}>
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: 8,
                  background: "linear-gradient(135deg, #22c55e, #16a34a)",
                }}
              >
                <i
                  className="fa fa-check"
                  style={{ fontSize: 14, color: "#fff" }}
                />
              </div>
              <div>
                <div
                  className="font-weight-bold"
                  style={{ fontSize: 15, color: "#166534" }}
                >
                  Présents
                </div>
                <div style={{ fontSize: 12, color: "#4ade80" }}>
                  {presentMembers.length} membre(s)
                </div>
              </div>
            </div>
            {presentMembers.length > 0 && (
              <div className="mb-2" style={{ position: "relative" }}>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Filtrer par nom..."
                  value={presentFilter}
                  onChange={(e) => setPresentFilter(e.target.value)}
                  style={{ fontSize: 13, borderRadius: 8, paddingRight: 30 }}
                />
                {presentFilter && (
                  <button
                    onClick={() => setPresentFilter("")}
                    style={{
                      position: "absolute",
                      right: 8,
                      top: "50%",
                      transform: "translateY(-50%)",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#94a3b8",
                      fontSize: 14,
                      padding: 0,
                      lineHeight: 1,
                    }}
                  >
                    <i className="fa fa-times" />
                  </button>
                )}
              </div>
            )}
            {presentMembers.length === 0 ? (
              <div
                className="text-center p-4 rounded"
                style={{ background: "#fff", border: "1px dashed #86efac" }}
              >
                <i
                  className="fa fa-users d-block mb-2"
                  style={{ fontSize: 24, color: "#94a3b8" }}
                />
                <span style={{ fontSize: 13, color: "#64748b" }}>
                  Aucun membre marqué présent
                </span>
              </div>
            ) : filteredPresent.length === 0 ? (
              <div
                className="text-center p-4 rounded"
                style={{ background: "#fff", border: "1px dashed #86efac" }}
              >
                <i
                  className="fa fa-search d-block mb-2"
                  style={{ fontSize: 20, color: "#94a3b8" }}
                />
                <span style={{ fontSize: 13, color: "#64748b" }}>
                  Aucun résultat pour « {presentFilter} »
                </span>
                <button
                  className="btn btn-sm btn-link d-block mx-auto mt-2"
                  onClick={() => setPresentFilter("")}
                  style={{ fontSize: 12 }}
                >
                  <i className="fa fa-times mr-1" />
                  Effacer le filtre
                </button>
              </div>
            ) : (
              filteredPresent.map((j) => (
                <MemberCard
                  key={`present-${j.userManager.id}`}
                  user={j.userManager}
                  isPresent={true}
                />
              ))
            )}
          </div>
        </div>
      </div>

      {/* Rédacteur / Président */}
      {presentMembers.length > 0 && (
        <div
          className="p-4 rounded mb-4"
          style={{
            background: "#fff",
            border: "1px solid #e2e8f0",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
          }}
        >
          <div className="d-flex align-items-center mb-3" style={{ gap: 10 }}>
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: 32,
                height: 32,
                borderRadius: 8,
                background: "linear-gradient(135deg, #3b82f6, #2563eb)",
              }}
            >
              <i
                className="fa fa-gavel"
                style={{ fontSize: 14, color: "#fff" }}
              />
            </div>
            <div>
              <div
                className="font-weight-bold"
                style={{ fontSize: 15, color: "#1e293b" }}
              >
                Désignation des rôles
              </div>
              <div style={{ fontSize: 12, color: "#94a3b8" }}>
                Sélectionnez le rédacteur et le président parmi les membres
                présents
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-5">
              <Control
                label="Rédacteur(trice)"
                name="writer"
                type="select"
                datas={presentMembers.map((j) => ({
                  name: tools.getFullname(j.userManager),
                  ...j.userManager,
                }))}
                dataIndex="id"
                dataLabel="name"
                value={writerPresident.writer}
                change={(e) =>
                  setWriterPresident({
                    ...writerPresident,
                    writer: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-12 col-md-5">
              <Control
                label="Président de séance"
                name="president"
                type="select"
                datas={presentMembers.map((j) => ({
                  name: tools.getFullname(j.userManager),
                  ...j.userManager,
                }))}
                dataIndex="id"
                dataLabel="name"
                value={writerPresident.president}
                change={(e) =>
                  setWriterPresident({
                    ...writerPresident,
                    president: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-12 col-md-2 d-flex align-items-end pb-2">
              <SaveBtn
                margin="mt-0 mb-2 "
                className="d-center"
                text="Valider"
                save={saveWriterPresident}
                isSaving={isSavingWriters}
              />
            </div>
          </div>
        </div>
      )}

      {/* Bouton appel terminé */}
      <div className="text-center">
        <button
          className="btn btn-lg"
          onClick={() => {
            if (onCallingDone) {
              onCallingDone();
            } else {
              saveCalling();
            }
          }}
          disabled={isSavingCalling || presentMembers.length === 0}
          style={{
            background:
              presentMembers.length > 0
                ? "linear-gradient(135deg, #22c55e, #16a34a)"
                : "#e2e8f0",
            color: presentMembers.length > 0 ? "#fff" : "#94a3b8",
            border: "none",
            padding: "14px 48px",
            fontSize: 16,
            fontWeight: 700,
            letterSpacing: 0.5,
            borderRadius: 12,
            boxShadow:
              presentMembers.length > 0
                ? "0 4px 14px rgba(34,197,94,0.3)"
                : "none",
            transition: "all 0.3s ease",
          }}
        >
          {isSavingCalling ? (
            <i className="fa fa-spinner fa-spin mr-2" />
          ) : (
            <i className="fa fa-arrow-right mr-2" />
          )}
          APPEL TERMINÉ — PASSER À LA SESSION
        </button>
        {presentMembers.length === 0 && (
          <div className="mt-2" style={{ fontSize: 13, color: "#94a3b8" }}>
            Marquez au moins un membre comme présent pour continuer
          </div>
        )}
      </div>
    </div>
  );
};

export default EpCallingV2;
